/**
 * Mobile Slider Auto-Scroll to Second Item
 * Automatically scrolls to the second item in mobile sliders on page load
 */

document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on mobile (750px and below)

    const mobileSliders = document.querySelectorAll('.section-content-wrapper.mobile-slider');
    
    mobileSliders.forEach(slider => {
      const imageBlocks = slider.querySelectorAll('.image-block');
      
      // Check if there's a second image-block (index 1)
      if (imageBlocks.length >= 2) {
        const secondImageBlock = imageBlocks[1];
        
        // Calculate the scroll position to center the second image-block
        const sliderWidth = slider.offsetWidth;
        const secondImageBlockWidth = secondImageBlock.offsetWidth;
        const scrollPosition = secondImageBlock.offsetLeft - (sliderWidth - secondImageBlockWidth) / 2;
        
        // Scroll to the second item with smooth behavior
        slider.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      }
    });
});

// Also handle window resize events to maintain functionality
window.addEventListener('resize', function() {
  // Debounce the resize event
  clearTimeout(window.mobileSliderResizeTimeout);
  window.mobileSliderResizeTimeout = setTimeout(function() {

      const mobileSliders = document.querySelectorAll('.section-content-wrapper.mobile-slider');
      
      mobileSliders.forEach(slider => {
        const imageBlocks = slider.querySelectorAll('.image-block');
        
        if (imageBlocks.length >= 2) {
          const secondImageBlock = imageBlocks[1];
          const sliderWidth = slider.offsetWidth;
          const secondImageBlockWidth = secondImageBlock.offsetWidth;
          const scrollPosition = secondImageBlock.offsetLeft - (sliderWidth - secondImageBlockWidth) / 2;
          
          slider.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
          });
        }
      });
    
  }, 250); // 250ms debounce
});
